import { computed, inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DocumentCenterStore } from '../../store/document/document-center.store';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs';
import { MemberStore } from '../../store/member/member.store';

export const documentsByMemberResolver: ResolveFn<any> = (route, state) => {
    const memberStore = inject(MemberStore)
    const documentCenterStore = inject(DocumentCenterStore)

    documentCenterStore.getDocumentsByMember(memberStore.id())

    return toObservable(
        computed(() => ({
            status: documentCenterStore.documentCenterStatus()
        }))
    ).pipe(
        filter(({status}) => status === 'success' || status === 'error'),
        take(1)
    )
};
